export class FootprintsEndpoints {
  static FundableProjects(partnerCode: string): string {
    return `/partner/${partnerCode}/fundableProjects`;
  }
}
